import React, { createElement } from 'react';
import { ModalForm } from '@ant-design/pro-components';
import { BaseDialog } from '../../shared/base/BaseDialog';
export default class ProModalForm extends BaseDialog {
    formRef = React.createRef();
    handleOpenChange = (open) => {
        if (!open) {
            this.hide();
        }
        if (this.props.onOpenChange) {
            this.props.onOpenChange(open);
        }
    };
    render() {
        const innerProps = this.transformProps();
        return (createElement(ModalForm, { formRef: this.formRef, dateFormatter: 'number', ...this.props, ...innerProps, modalProps: {
                destroyOnClose: true,
            }, onOpenChange: this.handleOpenChange }));
    }
}
